<div class="space-y-10">
  <!-- heading -->
  <h1 class="section-heading">
    {{ "MEDIATION.NOT_ELIGIBLE_TITLE" | translate }}
  </h1>

  <!-- alert box -->
  <div class="border border-gray-300 bg-gray-50 p-6 flex gap-4 items-start">
    <i
      class="fa-solid fa-triangle-exclamation text-amber-500 text-2xl mt-1"
    ></i>
    <div>
      <div class="font-semibold text-dc-black text-xl">
        @if (reason === 'nonMember') {
        {{ "MEDIATION.NON_MEMBER_HEAD" | translate }}
        } @if (reason === 'underAuthority') {
        {{ "MEDIATION.UNDER_AUTH_HEAD" | translate }}
        } @if (reason === 'nonCommercial') {
        {{ "MEDIATION.NON_COMMERCIAL_HEAD" | translate }}
        }
      </div>

      <!-- description -->
      <div class="text-lg mt-1 text-dc-black">
        @if (reason === 'nonMember') {
        {{ "MEDIATION.NON_MEMBER_DESC" | translate }}
        } @if (reason === 'underAuthority') {
        {{ "MEDIATION.UNDER_AUTH_DESC" | translate }}
        } @if (reason === 'nonCommercial') {
        {{ "MEDIATION.NON_COMMERCIAL_DESC" | translate }}
        }
      </div>
    </div>
  </div>

  <!-- contact channels -->
  <div class="grid sm:grid-cols-3 gap-10 text-dc-navy">
    <!-- chat -->
    <div class="flex flex-col items-start gap-2">
      <i class="fa-solid fa-headset text-3xl"></i>
      <h3 class="font-semibold">
        {{ "CONTACT.CHAT_TITLE" | translate }}
      </h3>
      <p class="text-sm text-dc-navy!">{{ "CONTACT.CHAT_DESC" | translate }}</p>
      <!-- <a class="text-dc-orange font-semibold underline">
        {{ "CONTACT.CHAT_NOW" | translate }}
      </a> -->
    </div>

    <!-- phone -->
    <div class="flex flex-col items-start gap-2">
      <i class="fa-solid fa-phone text-3xl"></i>
      <h3 class="font-semibold">
        {{ "CONTACT.PHONE_TITLE" | translate }}
      </h3>
      <p class="text-sm text-dc-navy!">
        {{ "CONTACT.PHONE_DESC" | translate }}
      </p>
      <a href="tel:8002426237" class="text-dc-orange underline font-semibold">
        {{ "CONTACT.PHONE_NUMBER" | translate }}
      </a>
    </div>

    <!-- visit -->
    <div class="flex flex-col items-start gap-2">
      <i class="fa-solid fa-circle-question text-3xl"></i>
      <h3 class="font-semibold">
        {{ "CONTACT.VISIT_TITLE" | translate }}
      </h3>
      <!-- <p class="text-sm text-dc-navy!">
        {{ "CONTACT.VISIT_DESC" | translate }}
      </p> -->
      <a
        class="text-dc-orange font-semibold underline"
        (click)="gotoContactUs()"
      >
        {{ "CONTACT.VISIT_LINK" | translate }}
      </a>
    </div>
  </div>
</div>
